<li>
  <div class="label-container">
    <i [class]="iconClass"></i>
    <span>{{ label }}</span>
  </div>
  <p *ngIf="!isTypeLink" class="d-flex align-items-center mb-0">
    <i *ngIf="fromChecklist && withCheck" class="pi pi-check text-success me-2"></i>
    <i *ngIf="fromChecklist && !withCheck" class="pi pi-times text-danger me-2"></i>
    {{ value }}
  </p>
  <a *ngIf="isTypeLink" [href]="href" target="_blank" rel noreferrer noopener>
    <p>{{ value }}</p>
  </a>
  <button
    (click)="copyValue($event)"
    [class.copied]="isCopy"
    (mouseleave)="isCopy = false"
  >
    <i class="fas fa-copy copy-icon"></i>
  </button>
</li>
